<template>
  <div class="zz" v-show="show">
    <div class="image-vcode-box">
      <div class="vc-head">
        <span>{{ $tm('components.imageVCode.title') }}</span>
        <span class="close-text" @click="closeWindow">{{ $tm('components.imageVCode.closeButton') }}</span>
      </div>
      <div class="img-box">
        <img :src="'data:image/jpeg;base64,'+image" @click="updateImageVCode" alt="">
        <input type="text" v-model="val">
      </div>
      <div class="button-box">
        <button @click="submit">{{ $tm('components.imageVCode.submitButton') }}</button>
      </div>
    </div>
  </div>
</template>
    
<script>
import { useI18n } from 'vue-i18n';
import { getImageVCode } from '@/api/common';

export default {
  name: "ImageVCode",
  props: {
    show: {
      type: Boolean,
      require: true
    },
    callback: {
      type: Function,
      required: true
    },
    closeCallback: {
      type: Function,
      required: true
    }
  },
  data(){
    return {
      uuid: null,
      image: null,
      val: null,
      tm: null,
    }
  },
  created(){
    const { tm, locale } = useI18n();
    this.tm = tm;
    this.getImageVCode();
  },
  methods:{
    submit(){
      if(!this.val || this.val == ''){
        alert(this.tm('components.imageVCode.remind1'));
        return;
      }
      if(this.callback){
        this.callback(this.uuid, this.val, this.updateImageVCode);
        this.val = ""
      }
    },
    closeWindow(){
      this.closeCallback();
    },
    updateImageVCode(){
      this.getImageVCode();
    },
    getImageVCode(){
      getImageVCode().then(res => {
        console.log(res)
        if(res.code == 0){
          let imageVCode = res.data
          this.image = imageVCode.image;
          this.uuid = imageVCode.uuid;
        }
      })
    }
  }
};
</script>

<style scoped>
/* 针对头部样式 */
.zz{
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999999;
  display: flex;
  align-items: center;
  justify-content: center;
}
.image-vcode-box{
  width: 500px;
  height: 300px;
  background-color: #FFFFFF;
  border-radius: 5px;
  position: relative;
}
.vc-head{
  width: 100%;
  height: 50px;
  border-bottom: 1px solid #dfdfdf;
}
.vc-head span{
  color: #333333;
  line-height: 50px;
  margin-left: 20px;
  font-weight: bold;
}
.vc-head .close-text{
  float: right;
  display: inline-block;
  height: 50px;
  width: 50px;
  margin-right: 10px;
  color: #999;
  cursor: pointer;
}
.img-box{
  width: 100%;
  padding: 30px;
}
.img-box img{
  width: 60%;
  height: 100px;
  position: relative;
  top: -10px;
}
.img-box input{
  width: 30%;
  text-align: center;
  font-size: 40px;
  line-height: 100px;
  margin-left: 20px;
}
.button-box{
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 70px;
  align-items: center;
  text-align: center;
}
.button-box button{
  width: 200px;
  height: 50px;
  background-color: blueviolet;
  border-radius: 5px;
  border: 0px;
  color: #FFF;
  cursor: pointer;
}
</style>
    